const contestResultsI18nAr = {
	"results-overview": "نظرة عامة",
	"results-members": "الأعضاء",
	"contest-submissions": "المشاركات خلال أيام المسابقة",
	day: "يوم",
	"the-day": "اليوم",
	submissions: "المشاركات",
	members: "الأعضاء",
	"top-3": "أفضل 3",
	"no-of-submissions": "عدد المشاركات",
	today: "اليوم",
	of: "من",
	score: "النقاط",
	date: "التاريخ",
	selectMember: "اختر العضو",
	selectDay: "اختر اليوم",
	totalPoints: "إجمالي النقاط",
	average: "متوسط",
	rank: "الترتيب",
	pointsPerDay: "النقاط لكل يوم",
	scorePerCategory: "النقاط لكل فئة",
	viewSubmissionsPerDay: "عرض المشاركات لكل يوم",
	close: "إغلاق",
	save: "حفظ",
	dailySubmissionsPopup: {
		title: "المشاركات لكل يوم",
		load: "عرض",
		date: "التاريخ",
		noData: "لا يوجد بيانات",
		criteriaTitle: "المعيار",
		answer: "الإجابة",
		noSubmissions: "لا يوجد مشاركات لهذا اليوم",
		selectDate: "اختر التاريخ",
		points: "النقاط",
		lastUpdated: "آخر تحديث",
		previousDays: "الأيام السابقة",
		nextDays: "الأيام التالية",
		editAnswer: "تعديل الإجابة",
		cancel: "إلغاء",
		addSubmission: "إضافة مشاركة",
	},
	"no-results": "لا يوجد نتائج",
	failedToSave: "فشل في الحفظ",
	back: "رجوع",
	showResults: "عرض النتائج",
	exportToExcel: "تصدير",
	exportResults: "تصدير النتائج",
	exportDateRange: "نطاق التاريخ",
	exportMembers: "الأعضاء",
	export: "تصدير",
	newExport: "تصدير جديد",
	noExports: "لا يوجد تصديرات بعد",
	noExportsTitle: "لا يوجد تصديرات بعد",
	noExportsDescription: "أنشئ تصديرًا جديدًا لتحميل نتائج المسابقة",
	createExport: "إنشاء تصدير",
	exportByMembers: "أعضاء محددين",
	selectSpecificMembers: "اختر أعضاء محددين",
	specificMembers: "أعضاء محددين",
	exportMaxDays: "لا يمكن أن يتجاوز نطاق التاريخ 31 يومًا",
	maxMembersExceeded: "الحد الأقصى 250 عضو لكل تصدير",
	exportPending: "قيد الانتظار",
	exportProcessing: "جاري المعالجة...",
	exportCompleted: "مكتمل",
	exportFailed: "فشل التصدير",
	existingExportFound: "يوجد تصدير بنفس البيانات مسبقًا",
	exportCreated: "تم طلب التصدير",
	downloadExport: "تحميل",
	downloadExcel: "تحميل Excel",
	downloadCsv: "تحميل CSV",
	downloadJson: "تحميل JSON",
	exportExpiresIn: "ينتهي خلال {{time}}",
	exportExpired: "منتهي الصلاحية",
	exportSuccess: "تم التصدير بنجاح",
	exportError: "فشل في تصدير النتائج",
	summary: "ملخص",
	detailedBreakdown: "تفاصيل",
	member: "العضو",
	criterion: "المعيار",
	total: "الإجمالي",
	totalSubmissions: "إجمالي المشاركات",
	contestTotal: "إجمالي المسابقة",
	allMembersSelected: "جميع الأعضاء محددين",
	membersSelected: "{{count}} أعضاء محددين",
	exportGroup: "المجموعة",
	allGroups: "جميع المجموعات",
	exportByGroup: "حسب المجموعة",
	exportAllMembers: "جميع الأعضاء",
	allGroupMembers: "جميع أعضاء المجموعة",
	groupRequired: "يرجى اختيار مجموعة",
	cancel: "إلغاء",
	delete: "حذف",
	deleteExportTitle: "حذف التصدير",
	deleteExportDescription: "هل أنت متأكد من حذف هذا التصدير؟",
};

export default contestResultsI18nAr;
